import { getCountryCodeByRegionId } from '@/constants/links'

export function useDownloadLinks() {
  const config = useRuntimeConfig()
  const route = useRoute()
  const { regionId } = useRegion()
  const siteIdSession = useSiteIdStorage()

  const destination = computed(() => `${config.public.webBaseUrl}${route.path}`)
  const countryCode = computed(() => getCountryCodeByRegionId(Number(regionId.value)).toLocaleLowerCase())

  const constructLink = (baseLink: string | undefined, extraParams: Record<string, string> = {}) => {
    if (!baseLink) return ''

    try {
      const url = new URL(baseLink)
      url.searchParams.set('destination', destination.value)
      url.searchParams.set('country_code', countryCode.value)

      for (const [key, value] of Object.entries(extraParams)) {
        url.searchParams.set(key, value)
      }

      return url.toString()
    } catch {
      return baseLink
    }
  }

  const iosLink = computed(() => constructLink(config.public.iosDownloadUrl))
  const androidLink = computed(() => constructLink(config.public.androidDownloadUrl))
  const unifiedLink = computed(() => constructLink(config.public.unifiedDownloadUrl, { site_id: siteIdSession.value }))

  const appIcons = computed(() => [
    { name: 'android app', src: '@/assets/images/marketing/google-play-download.svg', href: androidLink.value },
    { name: 'ios app', src: '@/assets/images/marketing/apple-store-download.svg', href: iosLink.value },
  ])

  return {
    iosLink,
    androidLink,
    unifiedLink,
    appIcons,
  }
}
